import * as Yup from 'yup';

export const adminAddNewsfeedSchema = Yup.object().shape({
    description: Yup.string().required("Required"),
});